import React, { useState, useEffect , Suspense } from 'react';

import PageBanner from '../components/PageBanner';
import { useNavigate } from 'react-router-dom';
import { REACT_APP_API_PORT } from '../Api';
import Loader from '../components/Loader';
import { getDecryptedData, removeStoredData, storeEncryptedData } from '../config/crypto';
import Alert from '../components/Alert';
import { useGoogleLogin } from '@react-oauth/google';
const Header = React.lazy(() => import('../components/headerfooter/Header'));
const Footer = React.lazy(() => import('../components/headerfooter/Footer'));
const CallToAction = React.lazy(() => import('../components/home/CallToAction'));

const GoogleLoginButton = ({location,apiIsLoading,handleGoogleLogin}) => {

  
  const [alertBox, setAlertBox] = useState(false)
  const [alert, setAlert] = useState({
    message: "",
    color: ""
  })
  const showAlert = (message, color) => {
    setAlert({ message: message, color: color })
  }

  const login = useGoogleLogin({
    onSuccess: async (credentialResponse) => {
      try {
        // Fetch user info from Google
        const res = await import('axios').then(({default: axios}) =>
        axios.get('https://www.googleapis.com/oauth2/v3/userinfo', {
          headers:{
            Authorization:`Bearer ${credentialResponse.access_token}`
          }
        })
      );

        const user = res.data;
        if (user) {
          handleGoogleLogin(user);
        }

        console.log('✅ User Info:', user);


      } catch (error) {
        console.error('❌ Failed to fetch user info:', error);
      }
    
    },
    onError: () => {
      console.error('Login Failed');
    },
  });

 

  return (
    <>
      <Alert alert={alert} alertBox={alertBox} setAlertBox={setAlertBox} />

      <button type='button' onClick={() => login()} className="bg-[linear-gradient(45deg,#d54d09,#e1307a,#9443ff,#436cff)] hover:bg-[linear-gradient(45deg,#ff7a18,#ff0066,#9b30ff,#3a7bd5)] transition-all duration-300 shadow-lg px-4 py-2 rounded-full text-white text-[15px] font-bold uppercase flex items-center justify-center">
          <img src="/images/google.png" alt="Google logo" width={26} height={26} className="mr-2 bg-[#ffffff] rounded-full p-1" />
          Sign in with Google
        </button>
   
    </> 
  );
};

const LoginPage = (props) => {
  const navigate = useNavigate();
  const [apiIsLoading, setApiIsLoading] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);
  const [savedEmail, setSavedEmail] = useState('');
   const [location, setLocation] = useState(null);

  useEffect(() => {
    const storedEmail = getDecryptedData("rememberedEmail");
    if (storedEmail) {
      setSavedEmail(storedEmail);
      setRememberMe(true);
    }
  }, []);

  useEffect(() => {
  const fetchLocation = async () => {
    try {
      const response = await fetch("https://ipinfo.io/json");
      const data = await response.json();
      setLocation(data);
    } catch (error) {
      console.error("Error fetching user location:", error);
    }
  };

    const timer = setTimeout(fetchLocation, 4000); // 🚀 delay for LCP optimization
    return () => clearTimeout(timer);
  }, []);

  const handleSubmit = async (values) => {
    try {
      setApiIsLoading(true);
      const axios = (await import('axios')).default;
      const res = await axios.post(`${REACT_APP_API_PORT}user/auth/login`, {
        email: values.email,
        password: values.password
      });
      setApiIsLoading(false);

      if (res.data.status) {
        storeEncryptedData("user", res.data.data);
        storeEncryptedData("token", res.data.jwtoken);

        if (rememberMe) {
          storeEncryptedData("rememberedEmail", values.email);
        } else {
          removeStoredData("rememberedEmail");
        }

        props.setAlertBox(true);
        props.showAlert(res.data.message, "success");
        navigate('/');
      }
    } catch (err) {
      console.log(err);
      setApiIsLoading(false);
      if (err.response?.data?.status === false) {
        props.setAlertBox(true);
        props.showAlert(err.response.data.message, "error");
      }
    }
  };


  const urlToFile = async (photoURL, fileName) => {
    try {
      const response = await fetch(photoURL);
      const blob = await response.blob();
      const file = new File([blob], fileName, { type: blob.type });
      return file;
    } catch (error) {
      console.error("Error converting photoURL to file:", error);
    }
  };


  const handleGoogleLogin = async (data) => {
    // const data = await signInWithPopup(auth, provider);

    if (!data) {
      props.setAlertBox(true)
      props.showAlert("Something went wrong!", "error")
      return;
    }

     let updateData = {
      name: data?.name,
      email: data?.email,
      // phone: data?.user?.phoneNumber,
      type: "Website",
      city: location?.city,
      country_code: location?.country,
      country_name: location?.country,
      // latitude:latitude,
      // longitude:longitude,
      postal: location?.postal,
      region: location?.region,
      region_code: location?.region_code,
      ip: location?.ip,
      ip_version: location?.version,
    }

    if (data?.user?.photoURL) {
      const profileImage = await urlToFile(data?.user?.photoURL, `image-${Date.now()}-${data?.user?.displayName}.jpg`);
      if (profileImage) {
        updateData.image = profileImage
      }
    }

    try {
      setApiIsLoading(true)
      const axios = (await import('axios')).default;
      const res = await axios.post(`${REACT_APP_API_PORT}user/auth/social-login`, updateData)
      setApiIsLoading(false)
      if (res.data.status) {
        storeEncryptedData("user", res.data.data);
        storeEncryptedData("token", res.data.jwtoken);

        
        // props.setAlertBox(true)
        // props.showAlert(res.data.message, "success")
        navigate('/')
      }
    }
    catch (err) {
      console.log(err)
      setApiIsLoading(false)
      if (err.response.data.status === false) {
        props.setAlertBox(true)
        props.showAlert(err.response.data.message, "error")
      }
    }

    console.log('Google Signup Clicked');
  };
  return (
    <>
      <Loader isLoading={apiIsLoading} />
      <Suspense fallback={null}>
      <Header />
    </Suspense>
      

      <div className="bg-background-back1 relative  justify-center items-center pb-16 px-6 pt-10">
        <PageBanner title="Join for Free Resources" para="Welcome back! Let’s dive into the world of AI" />
        
  {/* Login Box */}
  <div className="relative z-10 w-full max-w-md m-auto">
    <div className="w-full h-auto rounded-2xl md:rounded-3xl bg-[#ffffff0f] backdrop-blur-md p-5 md:p-10 shadow-xl ring-1 ring-white/10 text-[#141414]">

      {/* Logo Section */}
      <div className="flex items-center gap-2 mb-6 text-white">
        <a href="/">
          <img src="/images/NFA-Logo.png" alt="" width={180} height={40} />
        </a>
      </div>

       <h1 className="mb-2 text-xl lg:text-xl font-extrabold leading-tight text-white">
        <strong>#1</strong> Source to Become an AI Pro
      </h1>
     
      {/* <p className="text-[15px] text-gray-300">Free signup now & start earning AI Coins</p> */}
      <p className="text-[15px] text-gray-300">Free Sign-Up – Start Exploring Instantly!</p>

      {/* Signup Button */}
      <div className="flex flex-col gap-4 mt-6">
    
            <GoogleLoginButton 
            location={location}
              apiIsLoading={apiIsLoading}
               setApiIsLoading={setApiIsLoading}
                handleGoogleLogin={handleGoogleLogin} />

        {/* Features Section */}
        <div className="pt-2 text-white">
          <h2 className="mb-4 text-sm font-semibold lg:text-md">
            <sup>*</sup>By Signing Up, unlock these premium features:
          </h2>

          <div className="space-y-3">
            {features.map((feature, index) => (
              <div key={index} className="flex items-start gap-3">
                <span className="text-primary text-xl">{feature.icon}</span>
                <div>
                  <h3 className="text-[14px] font-medium lg:text-md">{feature.title}</h3>
                  <p className="text-sm text-gray-400">{feature.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  </div>
</div>



        
     <Suspense fallback={null}>
      <CallToAction />
    </Suspense>

    <Suspense fallback={null}>
      <Footer />
    </Suspense>
    </>
  );
};

export default LoginPage;


const features = [
  {
    title: 'Unlock 2000+ Viral AI Prompts ',
    description: 'One click to access all viral prompts collections',
    icon: '🔥'
  },
  {
    title: ' Master AI with Exclusive Courses',
    description: '100% practical, hands-on courses designed',
    icon: '📚'
  },
  {
    title: ' Explore 10,000+ AI Tools',
    description: 'Supercharge Your Productivity and Grow',
    icon: '🚀'
  },
  {
    title: ' Daily AI News ',
    description: 'Stay ahead with the latest AI trends',
    icon: '📰'
  }
];


